import { useSelector } from 'react-redux';
import { getProfileData } from '../store/profile.slice';
import { FeatureKey } from '../api/profile.api';

/**
 * Custom hook to check if a feature is accessible based on subscription limits
 *
 * Usage:
 * const { hasAccess, isBlocked } = useFeatureGate('can_use_workflows');
 *
 * if (isBlocked) {
 *   // Show upgrade prompt
 * }
 */
export const useFeatureGate = (feature: FeatureKey) => {
  const profile = useSelector(getProfileData);

  // Get the feature access status - subscription_limits is at root level of profile
  const features = profile?.subscription_limits?.features;
  const hasAccess = features?.[feature] ?? true; // Default to true if not defined
  const isBlocked = !hasAccess;

  return {
    hasAccess,
    isBlocked,
    features,
  };
};
